import { BUILDER_USER_TYPE } from "../../constants/custom-define-type";
import tryGet from '../../utils/try-get';
import axios from 'axios';
import { appendBackgroundParam } from "../../utils/query-handling";

const state = {
    importFieldChanged: [],
    pageScrollTop: 0,
    dialogScrollTop: 0,
    screenResizeCount: 0,
    emailSending: null,
    filePreview: null,
    monthNumbers: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
    ],
    upcomingYears: [
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
    ],
    hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    minuteOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
        '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
        '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
    minuteOptionsByFive: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
    minuteOptionsByFifteen: ['00', '15', '30', '45'],
    ampmOptions: ['AM', 'PM'],
    lastClickY: 0,
    displayingProfileUserId: null, // Use for normal user
    displayingProfileUser: null, // Use for normal user
    displayingCandidateId: null, // Use for admin
    displayingEmployerId: null, // Use for admin
    displayingCandidate: null, // Use for admin
    displayingEmployer: null, // Use for admin
    agent: null, // Login agent
    loadProfileTemplateListReqNumber: 0,
    reloadProfileTemplateListReqNumber: 0,
    loadCandidateProfileTemplateListReqNumber: 0,
    loadClientProfileTemplateListReqNumber: 0,
    isLoadingProfileTemplate: true, // After it is loaded => set to false
    profileTemplateList: [],
    candidateProfileTemplateList: [], // Profile template list for candidate
    clientProfileTemplateList: [], // Profile template list for client
    adminList: [],
    adminSetting: {},
    contextMenu: { options: [] },
    openProfileSectionId: null,
    loadPackageListReqNumber: 0,
    packageList: null,
    listDaysOfWeek: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
    ],
    hasMessage: false,
    totalNewMessages: 0,
    totalNewSMS: 0,
    totalNewTopics: 0,
    minutesIntervalOptionList: [
        {
            label: "5 minutes",
            model: 5
        },
        {
            label: "10 minutes",
            model: 10
        },
        {
            label: "15 minutes",
            model: 15
        },
        {
            label: "30 minutes",
            model: 30
        },
    ],
    languageDashboardOptions: [
        "English",
        "French",
        "Spanish"
    ],
    addProfileTemplateErrors: [],
    evaluationTemplatesList: [],
    evaluationTemplateErrors: [],
    newFeature: {},
    noteTemplates: [],
    noteTemplatesErrors: [],
    windowWidth: 0,
    hideMenuBar: false,
    iframePositionTop: null, // Position for iframe (embedded site),
    iframeParentHeight: null, // Windows height (embedded site)
    windowHeight: null, // Windows height (embedded site)
    iframeScaleY: null
};

const mutations = {
    setImportFieldChanged(state) {
        state.importFieldChanged = [];
    },
    addImportFieldChanged(state, fieldData) {
        state.importFieldChanged.push(fieldData);
    },
    deleteImportFieldChanged(state, index) {
        state.importFieldChanged.splice(index, 1);
    },
    setPageScrollTop(state, payload) {
        state.pageScrollTop = payload;
    },
    setDialogScrollTop(state, payload) {
        state.dialogScrollTop = payload;
    },
    increaseScreenResizeCount(state, payload) {
        state.screenResizeCount += payload;
    },
    setEmailSending(state, payload) {
        state.emailSending = payload;
    },
    setFilePreview(state, payload) {
        state.filePreview = payload;
    },
    setLastClickY(state, payload) {
        state.lastClickY = payload;
    },
    setDisplayingProfileUserId(state, payload) {
        state.displayingProfileUserId = payload;
    },
    setDisplayingProfileUser(state, payload) {
        state.displayingProfileUser = payload;
    },
    setDisplayingCandidateId(state, payload) {
        state.displayingCandidateId = payload;
    },
    setDisplayingEmployerId(state, payload) {
        state.displayingEmployerId = payload;
    },
    setDisplayingCandidate(state, payload) {
        state.displayingCandidate = payload;
    },
    setDisplayingEmployer(state, payload) {
        state.displayingEmployer = payload;
    },
    setAgent(state, payload) {
        state.agent = payload;
    },
    increaseLoadProfileTemplateListReqNumber(state, payload) {
        state.loadProfileTemplateListReqNumber += payload;
    },
    increaseReloadProfileTemplateListReqNumber(state, payload) {
        state.reloadProfileTemplateListReqNumber += payload;
    },
    increaseLoadCandidateProfileTemplateListReqNumber(state, payload) {
        state.loadCandidateProfileTemplateListReqNumber += payload;
    },
    increaseLoadClientProfileTemplateListReqNumber(state, payload) {
        state.loadClientProfileTemplateListReqNumber += payload;
    },
    setIsLoadingProfileTemplate(state, payload) {
        state.isLoadingProfileTemplate = payload;
    },
    setProfileTemplateList(state, payload) {
        console.log(payload);
        if (payload == null) {
            state.profileTemplateList = [];
            state.candidateProfileTemplateList = [];
            state.clientProfileTemplateList = [];
        } else {
            state.profileTemplateList = payload;
            state.candidateProfileTemplateList = payload.filter(builder => builder.user_type === BUILDER_USER_TYPE.CANDIDATE);
            state.clientProfileTemplateList = payload.filter(builder => builder.user_type === BUILDER_USER_TYPE.CLIENT);
        }
    },
    setCandidateProfileTemplateList(state, payload) {
        if (payload == null) {
            state.candidateProfileTemplateList = [];
        } else {
            state.candidateProfileTemplateList = payload;
        }
    },
    setClientProfileTemplateList(state, payload) {
        if (payload == null) {
            state.clientProfileTemplateList = [];
        } else {
            state.clientProfileTemplateList = payload;
        }
    },
    setAdminList(state, payload) {
        if (payload == null) {
            state.adminList = [];
        } else {
            state.adminList = payload;
        }
    },
    setAdminSetting(state, payload) {
        if (payload == null) {
            state.adminSetting = {};
        } else {
            state.adminSetting = payload;
        }
    },
    setContextMenu(state, payload) {
        if (payload == null) {
            state.contextMenu = {
                options: []
            }
        } else {
            state.contextMenu = payload;
        }
    },
    setOpenProfileSectionId(state, payload) {
        state.openProfileSectionId = payload;
    },
    increaseLoadPackageListReqNumber(state, payload) {
        state.loadPackageListReqNumber += payload;
    },
    setPackageList(state, payload) {
        if (payload == null) {
            state.packageList = [];
        } else {
            state.packageList = payload;
        }
    },
    setHasMessage(state, payload) {
        state.hasMessage = payload;
    },
    setTotalNewMessage(state, payload) {
        state.totalNewMessages = payload;
    },
    setTotalNewSMS(state, payload) {
        state.totalNewSMS = payload;
    },
    setTotalNewTopics(state, payload) {
        state.totalNewTopics = payload;
    },
    resetProfileTemplateErrors(state) {
        state.addProfileTemplateErrors = [];
    },
    async setProfileTemplate(state, payload) {
        await axios.post("/api/profiletemplates/", payload)
            .catch(error => {
                state.addProfileTemplateErrors.push(error);
            })
    },
    setEvaluationTemplatesByUserType(state, userType) {
        state.evaluationTemplatesList = userType;
    },
    setEvaluationTemplateErrors(state, userTypeErrors) {
        state.evaluationTemplateErrors.push(userTypeErrors);
    },
    setNewFeatures(state, payload) {
        state.newFeature = payload;
    },
    resetNoteTemplatesErrors(state) {
        state.noteTemplatesErrors = [];
    },
    setNoteTemplates(state, notes) {
        state.noteTemplates = notes;
    },
    setNoteTemplatesErrors(state, error) {
        state.noteTemplatesErrors.push(error);
    },
    setWindowWidth(state, payload) {
        state.windowWidth = payload;
    },
    setHideMenuBar(state, payload) {
        state.hideMenuBar = payload;
    },
    setIframePositionTop(state, payload) {
        state.iframePositionTop = payload;
    },
    setWindowHeight(state, payload) {
        state.windowHeight = payload;
    },
    setIframeParentHeight(state, payload) {
        state.iframeParentHeight = payload;
    },
    setIframeScaleY(state, payload) {
        state.iframeScaleY = payload;
    }
};

const actions = {
    setHideMenuBar({ commit }, isHide) {
        commit("setHideMenuBar", isHide);
    },
    addImportFieldChanged({ commit }, fieldData) {
        commit("addImportFieldChanged", fieldData);
    },
    resetImportFieldChanged({ commit },) {
        commit("setImportFieldChanged");
    },
    deleteImportFieldChanged({ commit }, index) {
        commit("deleteImportFieldChanged", index);
    },
    setPageScrollTop({ commit }, payload) {
        commit("setPageScrollTop", payload);
    },
    setDialogScrollTop({ commit }, payload) {
        commit("setDialogScrollTop", payload);
    },
    increaseScreenResizeCount({ commit }) {
        commit("increaseScreenResizeCount", 1);
    },
    setEmailSending({ commit }, payload) {
        commit("setEmailSending", payload);
    },
    setFilePreview({ commit }, payload) {
        commit("setFilePreview", payload);
    },
    setLastClickY({ commit }, payload) {
        commit("setLastClickY", payload);
    },
    setDisplayingProfileUserId({ commit }, payload) {
        commit("setDisplayingProfileUserId", payload);
    },
    setDisplayingProfileUser({ commit }, payload) {
        commit("setDisplayingProfileUser", payload);
    },
    setDisplayingCandidateId({ commit }, payload) {
        commit("setDisplayingCandidateId", payload);
    },
    setDisplayingEmployerId({ commit }, payload) {
        commit("setDisplayingEmployerId", payload);
    },
    setDisplayingCandidate({ commit }, payload) {
        commit("setDisplayingCandidate", payload);
    },
    setDisplayingEmployer({ commit }, payload) {
        commit("setDisplayingEmployer", payload);
    },
    setAgent({ commit }, payload) {
        commit("setAgent", payload);
    },
    increaseLoadProfileTemplateListReqNumber({ commit }, payload) {
        commit("increaseLoadProfileTemplateListReqNumber", payload);
    },
    increaseReloadProfileTemplateListReqNumber({ commit }, payload) {
        commit("increaseReloadProfileTemplateListReqNumber", payload);
    },
    increaseLoadCandidateProfileTemplateListReqNumber({ commit }, payload) {
        commit("increaseLoadCandidateProfileTemplateListReqNumber", payload);
    },
    increaseLoadClientProfileTemplateListReqNumber({ commit }, payload) {
        commit("increaseLoadClientProfileTemplateListReqNumber", payload);
    },
    setIsLoadingProfileTemplate({ commit }, payload) {
        commit("setIsLoadingProfileTemplate", payload);
    },
    setProfileTemplateList({ commit }, payload) {
        commit("setProfileTemplateList", payload);
    },
    setCandidateProfileTemplateList({ commit }, payload) {
        commit("setCandidateProfileTemplateList", payload);
    },
    setClientProfileTemplateList({ commit }, payload) {
        commit("setClientProfileTemplateList", payload);
    },
    setAdminList({ commit }, payload) {
        commit("setAdminList", payload);
    },
    setAdminSetting({ commit }, payload) {
        commit("setAdminSetting", payload);
    },
    setContextMenu({ commit }, payload) {
        commit("setContextMenu", payload);
    },
    setOpenProfileSectionId({ commit }, payload) {
        commit("setOpenProfileSectionId", payload);
    },
    increaseLoadPackageListReqNumber({ commit }, payload) {
        commit("increaseLoadPackageListReqNumber", payload);
    },
    setPackageList({ commit }, payload) {
        commit("setPackageList", payload);
    },
    setHasMessage({ commit }, payload) {
        commit("setHasMessage", payload);
    },
    loadAdminList({ commit, state, rootState }) {
        return new Promise(async (resolve) => {
            if (state.adminList && state.adminList.length) {
                resolve();
                return;
            }
            const res = await axios.get(
                "/api/people/?is_agent=true&agency=" +
                rootState.authentication.agencyID.toString()
            );
            res.data.sort(x => { return x.id == rootState.authentication.userId ? -1 : 0 })
            commit("setAdminList", res.data);
            resolve();
        });
    },
    reloadAdminList({ commit, rootState }) {
        return new Promise(async (resolve) => {
            const res = await axios.get(
                "/get-users/?user_type=admins&agency=" +
                rootState.authentication.agencyID.toString()
            );
            commit("setAdminList", res.data.users);
            resolve();
        });
    },
    setTotalNewMessage({ commit }, payload) {
        commit("setTotalNewMessage", payload);
    },
    setTotalNewSMS({ commit }, payload) {
        commit("setTotalNewSMS", payload);
    },
    setTotalNewTopics({ commit }, payload) {
        commit("setTotalNewTopics", payload);
    },
    reduceTotalNewSMS({ commit, state }, payload) {
        let newSMSCount = state.totalNewSMS - payload;
        if (newSMSCount < 0) {
            newSMSCount = 0;
        }
        commit("setTotalNewSMS", newSMSCount);
    },
    async loadMessagesSummary({ commit, rootState }) {
        if (rootState.authentication.userToken && rootState.authentication.userId) {
            const res = await axios.get(
                appendBackgroundParam("/chat/summary/")
            );
            if (res && res.data) {
                commit("setHasMessage", res.data.has_message);
                commit("setTotalNewMessage", res.data.count_new_messages);
                commit('setTotalNewSMS', res.data.count_new_sms);
                commit('setTotalNewTopics', res.data.count_new_topics);
            }
        }
    },
    addProfileTemplate({ commit }, template) {
        commit("resetProfileTemplateErrors");
        commit("setProfileTemplate", template);
    },
    async getNotesByUserType({ commit, rootGetters }, userType) {
        // userType: admin, employer, candidate
        const res = await axios.get(`get-notes?agency=${rootGetters.agencyID}&type=user_${userType}`);
        if (res && res.data) {
            return res.data.notes;
        }
    },
    async getEvaluationTemplatesByUserType({ commit, rootState }, userType) {
        let url = `/api/evaluationtemplates/?agency=${rootState.authentication.agencyID}`;
        if (userType) {
            url = `${url}&user_type=${userType}`;
        }
        await axios.get(url)
            .then(res => {
                commit("setEvaluationTemplatesByUserType", res.data);
            })
            .catch((error) => {
                commit("setEvaluationTemplateErrors", error.message);
            })
    },
    async addEvaluationTemplateToUser({ commit }, template) {
        await axios.post("/api/evaluations/", template)
            .catch((error) => {
                commit("setEvaluationTemplateErrors", error.message);
            })
    },
    fetchFeatures({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/api/bank_features")
                .then((response) => {
                    if (response.status == 200) {
                        commit('setNewFeatures', response.data);
                        resolve(response);
                    }
                })
                .catch((err) => {
                    reject(err);
                })
        })
    },
    async getNoteTemplatesByType({ commit, rootGetters }, templateSelector) {
        commit("resetNoteTemplatesErrors");
        await axios.get(`/api/richtemplates/?agency=${rootGetters.agencyID.toString()}&selector2=${templateSelector}`)
            .then((res) => {
                commit("setNoteTemplates", res.data);
            })
            .catch((error) => {
                commit("setNoteTemplatesErrors", error.message);
            });
    },
    setWindowWidth({ commit }, payload) {
        commit('setWindowWidth', payload);
    },
    getUserDetailsById({ commit }, userId) {
        if (!userId) {
            return null;
        }
        return new Promise(async (resolve) => {
            await axios.get(`/api/people/${userId}/`)
                .then(res => {
                    if (res && res.data) {
                        resolve(res.data);
                    }
                }).catch(error => {
                    reject();
                })
        });
    },
    setIframePositionTop({ commit }, payload) {
        commit('setIframePositionTop', payload);
    },
    setWindowHeight({ commit }, payload) {
        commit('setWindowHeight', payload);
    },
    setIframeParentHeight({ commit }, payload) {
        commit('setIframeParentHeight', payload);
    },
    setIframeScaleY({ commit }, payload) {
        commit('setIframeScaleY', payload);
    }
};

const getters = {
    getImportFieldChanged: state => tryGet(() => state.importFieldChanged) || '',
    profileTemplateErrors: state => tryGet(() => state.addProfileTemplateErrors) || [],
    evaluationTemplatesList: state => tryGet(() => state.evaluationTemplatesList) || [],
    evaluationTemplateErrors: state => tryGet(() => state.evaluationTemplateErrors) || [],
    noteTemplates: state => tryGet(() => state.noteTemplates) || [],
    noteTemplatesErrors: state => tryGet(() => state.noteTemplatesErrors) || [],
    pageScrollTop(state) {
        return state.pageScrollTop;
    },
    dialogScrollTop(state) {
        return state.dialogScrollTop;
    },

    hourOptions(state) {
        return state.hourOptions;
    },
    minuteOptions(state) {
        return state.minuteOptions;
    },
    minuteOptionsByFive(state) {
        return state.minuteOptionsByFive;
    },
    minuteOptionsByFifteen(state) {
        return state.minuteOptionsByFifteen
    },
    ampmOptions(state) {
        return state.ampmOptions;
    },
    lastClickY(state) {
        return state.lastClickY;
    },
    agent(state) {
        return state.agent;
    },
    profileTemplateList(state) {
        return state.profileTemplateList;
    },
    candidateProfileTemplateList(state) {
        return state.candidateProfileTemplateList;
    },
    clientProfileTemplateList(state) {
        return state.clientProfileTemplateList;
    },
    isLoadingProfileTemplate(state) {
        return state.isLoadingProfileTemplate
    },
    adminList(state) {
        return state.adminList || [];
    },
    adminSetting(state) {
        return state.adminSetting;
    },
    listTempHelpIdHidden(state) {
        const adminSetting = state.adminSetting;
        if (!adminSetting || !adminSetting.setting) {
            return [];
        }
        return adminSetting.setting.list_temp_help_id_hidden || [];
    },
    contextMenu(state) {
        return state.contextMenu;
    },
    packageList(state) {
        return state.packageList;
    },
    listDaysOfWeek(state) {
        return state.listDaysOfWeek;
    },
    monthNumbers(state) {
        return state.monthNumbers;
    },
    upcomingYears(state) {
        return state.upcomingYears;
    },
    hasMessage(state) {
        return state.hasMessage;
    },
    totalNewMessages(state) {
        return state.totalNewMessages;
    },
    totalNewSMS(state) {
        return state.totalNewSMS;
    },
    totalNewTopics(state) {
        return state.totalNewTopics;
    },
    minutesIntervalOptionList(state) {
        return state.minutesIntervalOptionList
    },
    languageDashboardOptions(state) {
        return state.languageDashboardOptions;
    },
    dashboardLanguage(state, getters, rootState) {
        const agency = rootState.agency.agencyPublic;
        if (agency.public_advance_setting) {
            const result = agency.public_advance_setting.dashboard_language;
            if (result) {
                return result;
            }
        }
        return "English"; // Default is english
    },
    getNewFeatures(state) {
        return state.newFeature;
    },
    adminOptionList(state) {
        if (!state.adminList) {
            return [];
        }
        return state.adminList.map((admin) => {
            return {
                label: `${admin.first_name} ${admin.last_name} - ${admin.email}`,
                id: admin.id,
                email: admin.email
            };
        });
    },
    adminOptionListByEmail(state) {
        if (!state.adminList) {
            return [];
        }
        return state.adminList.map((admin) => {
            return {
                label: `${admin.first_name} ${admin.last_name} - ${admin.email}`,
                model: admin.email,
            };
        });
    },
    windowWidth(state) {
        return state.windowWidth;
    },
    isMobileScreen(state) {
        return state.windowWidth <= 768;
    },
    hideMenuBar(state) {
        return state.hideMenuBar;
    },
    iframePositionTop(state) {
        return state.iframePositionTop
    },
    windowHeight(state) {
        return state.windowHeight;
    },
    iframeScaleY(state) {
        return state.iframeScaleY;
    },
    iframeParentHeight(state) {
        return state.iframeParentHeight;
    },
};

export default {
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/general.js